"use client";
import React from "react";
import Link from "next/link";
// import Image from "next/image";
import { usePathname } from "next/navigation";

interface BannerProps {
  block: {
    title?: string;
    description?: string;
  };
}

const Banner: React.FC<BannerProps> = ({ block }) => {
  const path = usePathname();
  return (
    <section>
      <div className="leader-banner bg-background-dark pt-[120px] lg:pt-[150px] pb-[56px] lg:pb-[80px] xl:pb-[100px] relative z-0">
        {/* Shapes */}
        {/* <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
          <Image
            src="/images/banner-left-layer-mobile.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-left-layer-tablet.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-left-layer-desktop.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden lg:block"
          />
        </div>
        <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
          <Image
            src="/images/banner-right-layer-mobile.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-right-layer-tablet.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-right-layer-desktop.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden lg:block"
          />
        </div> */}

        {/* Content */}
        <div className="container">
          <span className="text-gray-300 font-regular mb-[32px] block text-center text-subtitle-4">
            <Link href="/">Services</Link> /{" "}
            <Link href={path ?? "/"}>
              <span> {block?.title ?? ""}</span>
            </Link>
          </span>
          <div className="blog-heading mb-[32px]">
            <h1 className="text-center text-white font-[800] text-display uppercase mb-[12px]">
              {block?.title ?? ""}
            </h1>
            <p className="max-w-[1000px] mx-auto text-gray-50 text-center font-regular text-subtitle-3">
              {block?.description ?? ""}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
